import CIMSDivider from '../../../../../../../../../components/CIMSDivider'
import UserTags from '../../../../../../../../../components/CIMSTags/common/UserTags'
import { UserTagUser } from '../../../../../../../../../components/CIMSTags/common/UserTags/types'
import { HelpMessage } from '../../../../../../../../../utils/constants'
import { useRFINotificationsContext } from '../../RFINotificationsContext'
import { ResponderTagsProps } from './types'

const ResponderTags: React.FC<ResponderTagsProps> = ({
  responseDiscipline,
}) => {
  const { project } = useRFINotificationsContext()
  const users = responseDiscipline
    ? project?.rfiResponseDisciplines.find(
        ({ id }) => id === responseDiscipline.id
      )?.users ?? []
    : project?.rfiResponseDisciplines?.flatMap(({ users }) => users) ?? []
  const uniqueUsers = [...new Set(users.map((u) => JSON.stringify(u)))].map(
    (s) => JSON.parse(s) as UserTagUser
  )
  if (!uniqueUsers.length) return null
  return (
    <>
      <CIMSDivider
        help={HelpMessage.RequestsForInformation.Notifications.Responders(
          responseDiscipline
        )}
      >
        Responders
      </CIMSDivider>
      <UserTags users={uniqueUsers} />
    </>
  )
}

export default ResponderTags
